/**
 * Tab visibility helpers — flashing title + favicon dot + desktop notification
 * for new incoming messages while the tab is in the background.
 */

let originalTitle = null;
let flashInterval = null;
let unreadCount = 0;
let originalFavicon = null;

function snapshotOriginals() {
  if (originalTitle === null) originalTitle = document.title;
  if (originalFavicon === null) {
    const link = document.querySelector('link[rel="icon"]') || document.querySelector('link[rel="shortcut icon"]');
    originalFavicon = link?.href || '/favicon.ico';
  }
}

function setFavicon(href) {
  let link = document.querySelector('link[rel="icon"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = href;
}

function makeRedDotFavicon() {
  // Draw a simple icon (white square) with a red dot in top-right.
  const c = document.createElement('canvas');
  c.width = 32; c.height = 32;
  const ctx = c.getContext('2d');
  ctx.fillStyle = '#1a1a2e';
  ctx.fillRect(0, 0, 32, 32);
  ctx.fillStyle = '#ffffff';
  ctx.font = 'bold 18px sans-serif';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText('J', 16, 17);
  ctx.beginPath();
  ctx.fillStyle = '#ef4444';
  ctx.arc(24, 8, 7, 0, 2 * Math.PI);
  ctx.fill();
  return c.toDataURL('image/png');
}

function startFlashing() {
  snapshotOriginals();
  if (flashInterval) return;
  let alt = false;
  flashInterval = setInterval(() => {
    alt = !alt;
    document.title = alt
      ? `(${unreadCount}) 💬 Nouveau message`
      : originalTitle;
  }, 1200);
  setFavicon(makeRedDotFavicon());
}

export function stopFlashing() {
  if (flashInterval) {
    clearInterval(flashInterval);
    flashInterval = null;
  }
  unreadCount = 0;
  if (originalTitle !== null) document.title = originalTitle;
  if (originalFavicon !== null) setFavicon(originalFavicon);
}

/**
 * Call this whenever a new incoming message arrives.
 * - If the tab is hidden, increments unread count, starts flashing the title,
 *   updates the favicon and shows a desktop notification (if permitted).
 * - If the tab is visible, does nothing.
 */
export function notifyIncomingMessage({ title = 'Nouveau message', body = '', tag } = {}) {
  if (document.visibilityState === 'visible') return;
  unreadCount += 1;
  startFlashing();
  if (typeof Notification !== 'undefined' && Notification.permission === 'granted') {
    try {
      const n = new Notification(title, { body, tag, silent: false });
      n.onclick = () => { window.focus(); n.close(); };
    } catch (e) {
      if (process.env.NODE_ENV !== 'production') console.debug('[tabAlert] Notification:', e?.message);
    }
  }
}

export function requestDesktopPermission() {
  if (typeof Notification === 'undefined') return Promise.resolve('unsupported');
  if (Notification.permission === 'granted') return Promise.resolve('granted');
  if (Notification.permission === 'denied') return Promise.resolve('denied');
  return Notification.requestPermission();
}

// Stop flashing as soon as the tab regains focus.
if (typeof document !== 'undefined') {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') stopFlashing();
  });
}
